/**
 * Lockstep Platform SDK for TypeScript
 *
 * (c) 2021-2023 Lockstep, Inc.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author     Lockstep Network <support@lockstep.io>
 * @copyright  2021-2023 Lockstep, Inc.
 * @link       https://github.com/Lockstep-Network/lockstep-sdk-typescript
 */
export class ProvisioningClient {
    /**
     * Internal constructor for this client library
     */
    constructor(client) {
        this.client = client;
    }
    /**
     * Creates a new account for a developer, sending an email with information on how to access the API.
     *
     * @param body Documentation pending
     */
    provisionFreeDeveloperAccount(body) {
        const url = `/api/v1/Provisioning/free-account`;
        return this.client.request("post", url, null, body);
    }
}
//# sourceMappingURL=ProvisioningClient.js.map